export const FETCH_UI_SETTINGS_REQUEST = 'uiSettings/FETCH_UI_SETTINGS_REQUEST'
export const FETCH_UI_SETTINGS_SUCCESS = 'uiSettings/FETCH_UI_SETTINGS_SUCCESS'
export const FETCH_UI_SETTINGS_FAILURE = 'uiSettings/FETCH_UI_SETTINGS_FAILURE'

export const UPDATE_UI_SETTINGS_REQUEST =
  'uiSettings/UPDATE_UI_SETTINGS_REQUEST'
export const UPDATE_UI_SETTINGS_SUCCESS =
  'uiSettings/UPDATE_UI_SETTINGS_SUCCESS'
export const UPDATE_UI_SETTINGS_FAILURE =
  'uiSettings/UPDATE_UI_SETTINGS_FAILURE'

export const UPDATE_FIELD = 'uiSettings/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'uiSettings/SET_DEFAULT_DATA'
